var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useQueries } from '@tanstack/react-query';
import React from 'react';
import ActivityHistoryLink from '@/components/ActivityHistoryLink';
import useAppComponents from '@/hooks/useAppComponents';
import useNavigation from '@/navigation/useNavigation';
import { Text, View } from 'react-native';
export default function CrusherHistorySection() {
    const { api } = useAppComponents();
    const [totalConqueredPlaces, totalUpvotedPlaces] = useQueries({
        queries: [
            {
                queryKey: ['ConqueredPlacesForNumberOfItems'],
                queryFn: () => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    return (_a = (yield api.listConqueredPlacesPost({ limit: 1 })).data) === null || _a === void 0 ? void 0 : _a.totalNumberOfItems;
                }),
            },
            {
                queryKey: ['UpvotedForNumberOfItems'],
                queryFn: () => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    return (_a = (yield api.listUpvotedPlacesPost({ limit: 1 })).data) === null || _a === void 0 ? void 0 : _a.totalNumberOfUpvotes;
                }),
            },
        ],
    }).map(r => r.data);
    const totalNumberOfPlaces = totalConqueredPlaces !== null && totalConqueredPlaces !== void 0 ? totalConqueredPlaces : 0;
    const totalNumberOfUpvote = totalUpvotedPlaces !== null && totalUpvotedPlaces !== void 0 ? totalUpvotedPlaces : 0;
    const navigation = useNavigation();
    return (_jsxs(View, { className: "pt-3 px-5", children: [_jsx(Text, { className: "py-5 text-[18px] leading-[29px] font-pretendard-bold text-black", children: "\uC815\uBCF5 \uD788\uC2A4\uD1A0\uB9AC" }), _jsx(View, { className: "h-[1px] bg-gray-20" }), _jsx(ActivityHistoryLink, { elementName: "crusher_history_conquered_places_link", onPress: () => navigation.navigate('Conquerer/History'), title: "\uB0B4\uAC00 \uC815\uBCF5\uD55C \uC7A5\uC18C", count: totalNumberOfPlaces }), _jsx(ActivityHistoryLink, { elementName: "crusher_history_helpful_link", onPress: () => navigation.navigate('Conquerer/Upvote'), title: "\uB3C4\uC6C0\uC774 \uB3FC\uC694", count: totalNumberOfUpvote }), _jsx(ActivityHistoryLink, { elementName: "crusher_history_views_link", title: "\uB0B4 \uC815\uBCF5 \uC7A5\uC18C \uC870\uD68C\uC218", isWip: true })] }));
}
